<template>
    <div class="panel panel-login">
        <div class="row no-gutters icons justify-content-center">
            <ul class="nav">
                <li class="nav-item icon mx-3">
                    <router-link :to="{ name: 'portal.login' }">
                        <img :src="require('../../../assets/images/icon-login.png')" alt="">
                        <label>Login</label>
                    </router-link>
                </li>
                <li class="nav-item icon" >
                    <router-link :to="{ name: 'portal.home' }">
                        <img :src="require('../../../assets/images/icon-portal.png')" alt="">
                        <label>Portal</label>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="row no-gutters">
            <p>Não se encontra registado na aplicaçãoou não efetuou o login.</p>
            <p>Por favor registe-se ou faça o login de modo a ter acesso personalizado às ocorrências reportadas por si.</p>
        </div>
        <div class="row no-gutters" v-if="modules()">
            <div class="col-sm-12 modules">
                <!-- <router-link :to="{ name: module.portal.url }" v-for="(module,index) in $root.modules" :key="index" >
                    <div class="module shadow-lg" :class="'module-'+index" :style="{ backgroundImage: 'url(' + require('../../../'+module.path +'platforms/'+ $root.$env.PLATFORM + '/images/logo.png') + ')' }" data-toggle="tooltip" data-placement="top" :data-container="'.module-'+index" :title="module.name">
                    </div>
                </router-link> -->
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        mounted()
        {
            $('[data-toggle="tooltip"]').tooltip()
        },
        methods:
        {
            modules()
            {

                let modules = this.$root.$modules.filter(m => {
                    if(m.portal != null && m.portal.acl && this.$auth.check(m.portal.acl))
                    {
                        return true;
                    }
                    return false;
                });

                return modules.sort((a,b) => a.name - b.name);
            }
        }
    }
</script>

<style scoped lang="scss">
    .modules{
        padding:20px;
        .module{
            position: relative;
            width: 70px;
            height: 40px;
            float: left;
            margin-right: 10px;
            margin-bottom: 4px;
            text-align: center;
            vertical-align: middle;
            line-height: 150px;
            color: #FFF;
            cursor: pointer;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border:solid 1px #bdbdbd;

            @media screen and(max-width: 768px){
                &{
                    width:100%;
                }
            }
        }
    }
    .panel-login{
        display:none;
    }

    .icons{
        .icon{
            width:50px;
            text-align: center;
            cursor:pointer;
            border:0px;

            a{
                text-decoration:none;
            }

            img{
                width:38px;
                border-radius: 50%;
            }
            label{
                margin-bottom: 0px;
            }
        }
    }
</style>